import lozad from 'lozad';

export default {
  init() {
    // JavaScript to be fired on all pages
    const observer = lozad();
    observer.observe();

    (function($) {
      // Mobile Nav
      $('#nav-primary-toggle').click(function() {
        $('.nav-primary').toggleClass('open');
        $('.nav-backdrop').toggleClass('show');
      });

      $('#menu-header-menu li.menu-item-has-children').append('<div class="toggle lg:hidden absolute z-20 top-0 right-0 px-2 py-1"><i class="fa fa-chevron-down fa-xs"></i></div>');

      var timing = 200;

      $('#menu-header-menu > li.menu-item-has-children > .toggle').click(function() {
        if ($(this).parent().hasClass('open')) {
          $(this).parent().parent().find('li.menu-item-has-children').removeClass('open');
          $(this).parent().parent().find('.sub-menu').slideUp(timing);
        } else {
          $(this).parent().parent().find('li.menu-item-has-children.open').removeClass('open');
          $(this).parent().parent().find('li.menu-item-has-children.open > .sub-menu').slideUp(timing);
          $(this).parent().toggleClass('open');
          $(this).prev().slideToggle(timing);
        }
      });

      $('#menu-header-menu > li.menu-item-has-children > .sub-menu > li.menu-item-has-children > .toggle').click(function() {
        if ($(this).parent().hasClass('open')) {
          $(this).parent().parent().find('li.menu-item-has-children').removeClass('open');
          $(this).parent().parent().find('.sub-menu').slideUp(timing);
        } else {
          $(this).parent().parent().find('li.menu-item-has-children.open').removeClass('open');
          $(this).parent().parent().find('li.menu-item-has-children.open > .sub-menu').slideUp(timing);
          $(this).parent().toggleClass('open');
          $(this).prev().slideToggle(timing);
        }
      });

      // Desktop nav
      $('#menu-header-menu > li > .sub-menu > li.menu-item-has-children').hover(function() {
        if( $(window).innerWidth() > 991 ) {
          var target = $(this).find('> ul.sub-menu');
          var width = $(target).outerWidth();

          var right_of_screen = $(window).innerWidth();
          var right_of_parent = $(this).offset().left + $(this).outerWidth();
          var right_of_element = right_of_parent + width;

          if (right_of_screen > right_of_element){
            $(target).css('transform', 'translateX(100%)');
            $(target).css('right', '0');
          } else {
            $(target).css('transform', 'translateX(-100%)');
            $(target).css('left', '0');
          }
        }
      });

      $('.slick-banner').on('init', function() {
        var hiddenSlides = $('.slick-banner .hidden');
        if(hiddenSlides.length > 1) {
          $('.slick-banner .hidden').each(function(i, el) {
            $(el).removeClass('hidden');
          })
        } else {
          hiddenSlides.removeClass('hidden');
        }
      })

      // Slick
      $('.slick-banner').slick({
        dots: false,
        arrows: false,
        fade: true,
        cssEase: 'ease-in-out',
        slidesToShow: 1,
        slidestoScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 1000,
        infinite: true,
      });

      $('.slick-p').click(function() {
        $(this).parent().prev().slick('slickPrev');
      });
      $('.slick-n').click(function() {
        $(this).parent().prev().slick('slickNext');
      });

      $('.accreditationsSlider').slick({
        dots: false,
        arrows: false,
        fade: false,
        cssEase: 'ease-in-out',
        slidesToShow: 5,
        slidestoScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 1000,
        infinite: false,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 500,
            settings: {
              slidesToShow: 2,
            },
          },
        ],
      });

      $('.testimonialsSlider').slick({
        dots: false,
        arrows: false,
        fade: false,
        cssEase: 'ease-in-out',
        slidesToShow: 2,
        slidestoScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 1000,
        infinite: false,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,

            },
          },
        ],
      });

      $('.first-gallery').slick({
        dots: false,
        arrows: false,
        fade: true,
        cssEase: 'ease-in-out',
        slidesToShow: 1,
        slidestoScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 1000,
        infinite: true,
      });

      $('.second-gallery').slick({
        dots: false,
        arrows: false,
        fade: true,
        cssEase: 'ease-in-out',
        slidesToShow: 1,
        slidestoScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 1000,
        infinite: true,
      });

      $('.third-gallery').slick({
        dots: false,
        arrows: false,
        fade: true,
        cssEase: 'ease-in-out',
        slidesToShow: 1,
        slidestoScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 1000,
        infinite: true,
      });

       // Fixed CTA

       $(window).scroll(function() {
        // Change 100 to the amount of pixels down the page you want the event to trigger
        if ($(document).scrollTop() > 100) {
          // Trigger this event when scrolled below pixels
          $('.cta-fixed').addClass('active');
        }
        else {
          // Trigger this event when scrolled above pixels
          $('.cta-fixed').removeClass('active');
        }
        if($(window).scrollTop() + $(window).height() == $(document).height()) {
          $('.cta-fixed').removeClass('active');
        }
      });


      // accordion

      $('.toggle').click(function() {


        var $this = $(this);
        console.log($this);

        if ($this.next().hasClass('show')) {
          $this.removeClass('active');
          $this.next().removeClass('show');
          $this.next().slideUp(350);
        } else {
          $('.toggle').removeClass('active');
          $this.parent().parent().find('li .inner').removeClass('show');
          $this.parent().parent().find('li .inner').slideUp(350);
          $this.addClass('active');
          $this.next().toggleClass('show');
          $this.next().slideToggle(350);
        }
    });


      // Cookie Policy
      $.fn.CookieNotice = function() {
        if (!localStorage.getItem('cookie-notice-dismissed')) {
          var notice = this;
          setTimeout(function() {
            notice.addClass('active');
          }, 1000);
        }
        this.addClass('cookie-notice');
        return this
      }
      $(document).on('click', '.cookie-notice-dismiss', function() {
        localStorage.setItem('cookie-notice-dismissed', true);
        $(this).parents('.cookie-notice').removeClass('active');
      })
      $('#cookie-notice').CookieNotice();

      // Share Button
      $('.page-share').click(function() {
        if( navigator.share ) {
          navigator.share({
            title: 'Share This Page',
            url: 'https://google.com',
          }).then(() => {
            console.log('Thanks for sharing!');
          })
          .catch(err => {
            console.log('Couldnt share because of', err.message);
          });
        } else {
          $('#panel-share').toggleClass('active');
          console.log('navigator.share not supported!')
        }
      });

      $('.panel-share-close').click(function() {
        $('#panel-share').removeClass('active');
      });
    })(jQuery);
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
(function($) {
  //nav logo append
  var $navLogo = $( '<img src=\'/app/uploads/2022/04/Logo-Gold.jpg\' alt=\'exclusive commercials logo\' class=\'nav-logo\'>' )
  $( '.menu-exclusive-commercials-ltd' ).append($navLogo);
})(jQuery);



// WEBPACK FOOTER //
// ./scripts/routes/common.js